import _get from 'lodash/get';

import { objectToCamelCase } from '../../../../libs/format';

export function selectCustomPages(state) {
  return Object.values(objectToCamelCase(_get(state, 'customPages.entities', [])));
}
